import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLocale } from '../contexts/LocaleContext';
import { Signup } from './Signup';
import { Button } from './ui/button';
import { LanguageSelect } from './LanguageSelect';

export const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLocale();
  const { token, loading } = useAuth();

  useEffect(() => {
    if (!loading && token) {
      navigate('/desk');
    }
  }, [token, loading, navigate]);

  if (loading) {
    return null;
  }

  if (token) {
    return null;
  }

  return (
    <div className="bg-background">
      <div className="mx-auto mb-4 flex w-full max-w-[400px] justify-end px-4 pt-8">
        <LanguageSelect />
      </div>
      <Signup onSwitchToLogin={() => navigate('/login')} />
      <div className="mx-auto mt-3 max-w-[400px] text-center">
        <Button
          onClick={() => navigate('/waitinglist')}
          variant="outline"
          className="mb-2"
        >
          {t('waiting_list_button')}
        </Button>
        <p className="m-0 text-sm text-muted-foreground">
          {t('request_early_access_subheading')}
        </p>
      </div>
    </div>
  );
};

